<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span><el-page-header content="搭桥快跑" @back="goBack" /></span>
          <el-card style="margin-top: 10px;">
            <div slot="header" class="clearfix">
              <el-row :gutter="10">
                <CommonExcel
                  ref="CommonExcelRef"
                  :import-p="'config:rewardRunForItEdit:import'"
                  :export-p="'config:rewardRunForItEdit:export'"
                  :import-method="importBaseCfg"
                  :export-method="exportBaseCfg"
                />
              </el-row>
            </div>
            <el-table size="mini" :data="baseList" border style="width: 100%;min-height: 100px;" highlight-current-row>
              <el-table-column align="center" label="序号" width="50">
                <template slot-scope="{row, $index}">
                  <span style="display:block">{{ $index+1 }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="最小等级" width="150">
                <template slot-scope="{row, $index}">
                  <el-input v-model="row.minLv" placeholder="最小等级" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="最大等级" width="150">
                <template slot-scope="{row, $index}">
                  <el-input v-model="row.maxLv" placeholder="最大等级" />
                </template>
              </el-table-column>
              <el-table-column label="用户分组" min-width="100%" align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.groupIds" multiple>
                    <el-option v-for="item in groupsList" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column align="center" label="广告次数" width="150">
                <template slot-scope="{row, $index}">
                  <el-input v-model="row.adsTimes" placeholder="广告次数" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="权重" width="150">
                <template slot-scope="{row, $index}">
                  <el-input v-model="row.pro" placeholder="权重" />
                </template>
              </el-table-column>
              <el-table-column label="奖励配置" align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.rewardId">
                    <el-option v-for="item in list[2]" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="复活配置" align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.revive">
                    <el-option v-for="item in list[3]" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="倍率系数配置" align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.bet">
                    <el-option v-for="item in list[5]" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="地图配置" align="center">
                <template slot-scope="scope">
                  <div style="width: 100%;height: 100%;min-height: 1rem;white-space: pre-wrap" @click="handleEditMapWeight(scope.row.mapWeight, scope.$index)">
                    <i class="el-icon-edit-outline" style="margin-right: 0.5rem" /><pre>{{ handleMapWeight(scope.row.mapWeight) }}</pre>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="100">
                <template slot-scope="{row,$index}">
                  <el-button v-permisaction="['config:rewardRunForItEdit:del']" size="mini" type="danger" @click="deleteBaseConfig($index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="float:left;margin-top: 1rem">
              <el-button v-permisaction="['config:rewardRunForItEdit:add']" type="primary" size="mini" @click="addBaseConfig()">新增</el-button>
              <el-button v-permisaction="['config:rewardRunForItEdit:add']" type="primary" :disabled="isOnline === 1" size="mini" style="margin:10px 10px" @click="handleSaveBase()">保存</el-button>
            </div>
          </el-card>
        </div>
        <el-dialog title="地图权重" :visible.sync="mapDialog" width="40%" @close="dialogCLose">
          <el-table size="mini" :data="mapDialogList" border fit highlight-current-row style="width: 100%;" height="500">
            <el-table-column label="权重" align="center">
              <template slot-scope="{row,$index}">
                <el-input v-model="row.v" style="width: 250px;" placeholder="权重" />
              </template>
            </el-table-column>
            <el-table-column label="速度" align="center" width="150">
              <template slot-scope="{row,$index}">
                <el-input v-model="row.speed" placeholder="速度" />
              </template>
            </el-table-column>
            <el-table-column label="移动距离" align="center" width="150">
              <template slot-scope="{row,$index}">
                <el-input v-model="row.distance" placeholder="速度" />
              </template>
            </el-table-column>
            <el-table-column label="地图" align="center">
              <template slot-scope="scope">
                <el-select v-model="scope.row.id">
                  <el-option v-for="item in list[1]" :value="item.id" :label="item.name" />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="背景" align="center">
              <template slot-scope="scope">
                <el-select v-model="scope.row.background">
                  <el-option v-for="item in list[4]" :value="item.id" :label="item.name" />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template slot-scope="{row,$index}">
                <el-button style="margin-left: .5rem;display:block" type="danger" size="mini" @click="deleteMapDialogList($index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <span slot="footer" class="dialog-footer" style="margin-right: 10px"><el-button type="primary" @click="addMapDialogList">新增</el-button></span>
          <span slot="footer" class="dialog-footer"><el-button @click="mapDialog = false">关 闭</el-button></span>
        </el-dialog>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getUserTypeAllList } from '@/api/config/user-group-cfg'
import { actAuxiliary } from '@/api/config/activity-auxiliary-cfg'
import { getActivtyList, updateActivtyRewardConfData } from '@/api/config/activity-cfg'
import CommonExcel from '@/components/CommonExcel/index.vue'
import { downloadExcelMultiSheet } from '@/utils/excel'
export default {
  name: 'RewardRunForItEdit',
  components: { CommonExcel },
  data() {
    return {
      mapDialog: false,
      mapDialogList: [],
      mapDialogIndex: -1,
      list: [],
      baseList: [],
      groupsList: [{ name: '默认分组', id: 0 }],
      curClass: 'run_for_it',
      rewardConf: [],
      isOnline: 0,
      typeArr: { 1: '地图配置', 2: '奖励配置', 3: '复活配置' }
    }
  },
  created() {
    this.aid = this.$route.query.id
    this.actType = this.$route.query.type
    this.ucType = this.$route.query.uc_type
    this.isOnline = parseInt(this.$route.query.is_online)
    this.init()
  },
  methods: {
    init() {
      this.getActivity()
      this.getList()
      this.initBase()
    },
    initBase() {
      getUserTypeAllList().then(res => {
        res.data.forEach(res => {
          this.groupsList.push({ name: res.name, id: res.groupId })
        })
      })
    },
    getList() {
      this.loading = true
      actAuxiliary({ class: this.curClass, select: 0 }).then(response => {
        this.list = response.data
        for (const key in this.typeArr) {
          if (this.list[key] === undefined || this.list[key] == null) {
            this.list[key] = []
          }
        }
        this.loading = false
      })
    },
    addBaseConfig() {
      this.baseList.push({ minLv: 1, maxLv: 999, adsTimes: 0, pro: 0, groupIds: [], rewardId: 0, bet: 0 })
    },
    deleteBaseConfig(index) {
      this.baseList.splice(index, 1)
    },
    handleSaveBase() {
      for (const i in this.baseList) {
        const val = this.baseList[i]
        if (!val.groupIds) {
          this.msgError('请选择分组')
          return
        }
      }
      const data = JSON.stringify(this.baseList)
      console.log('postData', data)
      updateActivtyRewardConfData({ name: this.aid, data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getActivity()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getActivity() {
      getActivtyList({ id: this.aid }).then(res => {
        if (res.code === 200) {
          this.baseList = res.data.list[0].reward_conf
          if (!this.baseList) {
            this.baseList = []
          }
        }
      })
    },
    goBack() {
      this.$router.push({ path: '/config/activity-config/index' })
    },
    importBaseCfg(excelInfo) {
      const excelData = excelInfo.data
      for (let i = 0; i < excelData.length; i++) {
        this.baseList = this.$refs.CommonExcelRef.tranToTarget(excelData[i].sheetData, { groupIds: this.groupsList, rewardId: this.list[2] }, true, 'name', 'id')
        break
      }
    },
    exportBaseCfg() {
      const fileName = '搭桥快跑活动配置'
      const hearer = []
      const excelData = []
      const name = ['搭桥快跑活动配置']
      const list = this.$refs.CommonExcelRef.tranToTarget(this.baseList, { groupIds: this.groupsList, rewardId: this.list[2] }, true, 'id', 'name')
      const tAk = this.$refs.CommonExcelRef.makeExcelData(list, { minLv: '最小等级', maxLv: '最大等级', adsTimes: '广告次数', pro: '权重', groupIds: { name: '用户分组', sub: [] }, rewardId: '奖励配置' })
      hearer.push(tAk[0])
      excelData.push(tAk[1])
      downloadExcelMultiSheet(this.$route.meta.title + fileName, name, hearer, excelData)
    },
    handleEditMapWeight(config, index) {
      this.mapDialog = true
      this.mapDialogList = config
      this.mapDialogIndex = index
    },
    handleMapWeight(data) {
      let str = ''
      if (!data) {
        return str
      }
      for (let i = 0; i < data.length; i++) {
        str += '权重：' + data[i].v + '，地图：' + this.handleGetMapName(data[i].id) + '\n'
      }
      return str
    },
    addMapDialogList() {
      if (!this.mapDialogList) {
        this.mapDialogList = []
      }
      this.mapDialogList.push({ v: 0, speed: 0, distance: 6, id: 0 })
    },
    deleteMapDialogList(index) {
      this.mapDialogList.splice(index, 1)
    },
    dialogCLose() {
      for (const i in this.baseList) {
        if (i == this.mapDialogIndex) {
          this.baseList[i].mapWeight = this.mapDialogList
        }
      }
    },
    handleGetMapName(id) {
      for (let i = 0; i < this.list[1].length; i++) {
        if (this.list[1][i].id === id) {
          return this.list[1][i].name
        }
      }
      return ''
    }
  }
}
</script>

<style scoped>
</style>
